import React, {useState} from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Slide } from 'react-slideshow-image';

import Features from "components/Features";
import Img from "components/Img";
import Button from "components/Button";

import routes from "configs/routes";

import { formatFloor, formatStatus, formatMoney } from "functions/formatDynamicData";

import 'react-slideshow-image/dist/styles.css';
import { formatOrientation } from "functions/formatDynamicData";
import clg from "functions/log";


const ApartmentListItemSquare = ( { id, code, status, floor, floor_area, rooms, images, orientation, price } ) => {

    const [isHovered, setIsHovered] = useState(false);

    const detailsButtonVariants = {
        show : {
            opacity: 1,
            top:"50%",
        },
        hide : {
            opacity:0,
            top:"100%",
        }
    }

    return (
        
        <Link to={ routes.apartment.replace(":id", code) } className={"col-lg-6 apartment-list-item-square " + formatStatus( status, "class" )}>
            <motion.div 
                className="inner"
                onHoverStart={() => setIsHovered(true)}
                onHoverEnd={() => setIsHovered(false) }
                whileHover={{
                    y : -10,
                }}
            >
                <div className="inner-up">

                    <Slide className="image-slider"
                        arrows={false}
                        canSwipe={false}
                        pauseOnHover={false}
                        duration={750}
                        transitionDuration={1000}
                        autoplay={ isHovered }
                    >
                    {images.map((slideImage, index)=> (
                        <Img src={ slideImage } skeletonprops={{ height : "100%" }} key={"apartment-list-item-slide-image-" + index } />
                    ))} 
                    </Slide> 
                    
                    <div className="apartment-id">{code}</div>
                    <div className={"apartment-status " + formatStatus( status, "class" ) }>{  formatStatus( status, "name" ) }</div>
                    <div className={"apartment-price"}><i className="fas fa-tag"></i>{ ( price !== "0" ? formatMoney( price, "M Ft",  ) : "Érdeklődjön" ) }</div>
                    <div className={"apartment-orientation " + formatOrientation( orientation, "value" ) }><i className="far fa-compass"></i>{ formatOrientation( orientation, "label" ) }</div>
                    
                    <AnimatePresence>
                        { isHovered && (
                            <motion.div className="details-button"
                                variants={ detailsButtonVariants }
                                initial="hide"
                                exit="hide"
                                animate={ isHovered ? "show" : "hide" }
                            >
                                <Button className="btn-secondary" text="Részletek"/>
                            </motion.div>
                        )
                    }
                    </AnimatePresence>

                </div>
                <div className="inner-down">
                <Features featureItemClass="col-4 single-feature" boxFeatureClass="no-shadow apartment-data" data={
                [
                    { title : "Emelet", data : { value: formatFloor(floor) }, dataTagAdditionalClass : "floor-" + floor  },
                    { title : "Bruttó alapterület", data : { value : floor_area, postfix: "m2"},  },
                    { title : "Szobák", data : { value: rooms } },
                ]} />
                </div>
            </motion.div>
        </Link>
    )
}

export default ApartmentListItemSquare;